/**
 * @generated SignedSource<<9f00c88f67f493ce4081d9bfc2ddaffd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type composerSaveActionDialogPrintTypesQuery$variables = Record<PropertyKey, never>;
export type composerSaveActionDialogPrintTypesQuery$data = {
  readonly printTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly printTypeID: number;
      };
    }> | null;
  } | null;
};
export type composerSaveActionDialogPrintTypesQuery = {
  response: composerSaveActionDialogPrintTypesQuery$data;
  variables: composerSaveActionDialogPrintTypesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      }
    ],
    "concreteType": "PrintTypesConnection",
    "kind": "LinkedField",
    "name": "printTypes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PrintTypesEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrintType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "printTypeID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "printTypes(first:200)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "composerSaveActionDialogPrintTypesQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "composerSaveActionDialogPrintTypesQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "aea6229963f85b1a0e24cfb5d8a52354",
    "id": null,
    "metadata": {},
    "name": "composerSaveActionDialogPrintTypesQuery",
    "operationKind": "query",
    "text": "query composerSaveActionDialogPrintTypesQuery {\n  printTypes(first: 200) {\n    edges {\n      node {\n        id\n        printTypeID\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc2e5fe9a9fead9d30b4f74e37d45577";

export default node;
